import { App } from '../../types'

import { CardMedia, Box, styled } from '@mui/material'
import defaultIcon from 'assets/icons/icon-av-web.svg'

const Root = styled(Box)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),

  '& .MuiCardMedia-root': {
    width: '100%',
    borderRadius: '4px',
    backgroundColor: theme.palette.grey[100]
  }
}))

function AppsCardMedia({ app }: { app: App }) {
  const handleImageError = (e) => {
    e.target.src = defaultIcon
  }

  return (
    <Root>
      <CardMedia
        image={app.thumbnail_url || defaultIcon}
        title={app.title}
        component="img"
        onError={handleImageError}
      />
    </Root>
  )
}

export default AppsCardMedia
